// extracted by mini-css-extract-plugin
export var banner = "_3v-0";
export var icon = "_3v-1";
export var message = "_3v-2";